<script>

import {checkLoginWidthAppMessage, sendAppMessage} from "@/util/sendAppMessage";

const VerticalCoverImageBaseUrl = "common/shorts/vertical/";
const OSS_Domain = "https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/";
export default {
  name: "collection",
  components: { },
  data() {
    return {
      teacher_id: null,
      oss: OSS_Domain,
      verticalCoverImageBaseUrl: VerticalCoverImageBaseUrl,
      teacherInfo: null,
      videoList: [],
      page: 1,
      loading: true,
      device: ""
    };
  },
  mounted() {
    this.device = localStorage.getItem("device") || "mp";
    this.teacher_id = this.$route.query.teacher_id;
    if(!this.teacher_id) {
      this.$toast.fail("缺少参数");
      this.$router.back();
      return;
    }
    this.getTeacher();
    this.getVideoList();
  },
  methods: {
    async getTeacher() {
      try {
        let res = await this.$axios.get("/teacher/getTeacherInfo", {
          params: {
            teacher_id: this.teacher_id
          }
        });
        this.teacherInfo = res.data;
      } catch (e) {
        this.$router.back();
      }
    },
    async getVideoList() {
      this.loading = true;
      try {
        let res = await this.$axios.get("/shorts/getShortsList", {
          params: {
            page: this.page,
            teacher_id: this.teacher_id
          }
        });
        this.videoList = res.data;
        this.loading = false;
      } catch (e) {
        // this.$router.back();
        this.videoList = [];
        this.loading = false;
      }
    },
    onClickGo() {
      if(!checkLoginWidthAppMessage()) {
        return;
      }
      sendAppMessage({jump_type: 2, jump_url: this.teacher_id});
    },
    onClickItem(v) {
      this.$router.push("/moment/collect-play?id=" + v.id);
    }
  }
};
</script>

<template>
  <div class="moment-collection">
    <div class="h sticky top-0 z-10">
      <div class="header-title bg-white p-3 border-b flex justify-between items-center">
        <i class="el-icon-arrow-left text-2xl" @click="$router.back()"></i>
        <p>老师专区</p>
        <i class="el-icon-arrow-left" style="color: transparent"></i>
      </div>
      <div v-if="teacherInfo" class="bg-white p-3">
        <div class="header flex justify-between items-center">
          <div class="relative">
            <img :src="teacherInfo.img_small_arr[this.device]" alt="" class="teacher-cover">

          </div>
          <div class="flex-1 h-full px-3 flex flex-col justify-between">
            <div>
              <h3 class="text-2xl mb-3">{{ teacherInfo.name }}</h3>
              <p class="text-sm">执业证书：{{ teacherInfo.number }}</p>
            </div>
          </div>
        </div>
        <div v-if="teacherInfo" class="mt-3">
          <van-button block type="info" @click="onClickGo">进入老师专区</van-button>
        </div>
      </div>
    </div>
    <div class="content">
      <div v-if="videoList && videoList.length > 0" class="list p-3">
        <div v-for="(video, index) in videoList" :key="index" class="item mb-3 relative rounded overflow-hidden shadow p-3 bg-white" @click="onClickItem(video)">
          <div class="relative">
            <img :src="video.img" alt="" class="w-full rounded">
            <div class="play">
              <img alt="" src="https://shengjin.oss-cn-hangzhou.aliyuncs.com/weizhen/common/icon/index/play_button.png">
            </div>
          </div>
          <div class="absolute left-3 right-3 bottom-3 overflow-hidden p-3 rounded" style="background-color: rgba(0,0,0,.5)">
            <p class="w-full truncate text-white">{{video.title}}</p>
          </div>
        </div>
      </div>
      <div v-if="!loading && (videoList.length <= 0 || !teacherInfo)">
        <van-empty description="暂无数据"/>
      </div>
    </div>
  </div>
</template>

<style scoped>
/**
.header {
  height: 11.25rem;
}

.header .teacher-cover {
  width: 7.5rem;
  height: 11.25rem;
}
**/

.moment-collection {
  background-color: #F0F0F0;
  margin-top: 0 !important;
  min-height: 100vh;
}

.header {
  height: 5rem;
}

.header .teacher-cover {
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
}

.play {
  position: absolute;
  inset: 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,.2);
}

.play img {
  width: 2rem;
  height: 2rem;
}
</style>
